import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface BrandsSearchItemsMoreMetricsProps {
  cpaIncome: string;
  rsIncome: string;
  totalIncome: string;
  pv: string;
  epc: string;
  epcCpc: string;
}

const BrandsSearchItemsMoreMetrics = ({
  cpaIncome,
  rsIncome,
  totalIncome,
  pv,
  epc,
  epcCpc,
}: BrandsSearchItemsMoreMetricsProps) => {
  return (
    <>
      <Stack>
        <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              CPA INCOME
              <Box sx={{ fontWeight: typography.Font_weight.Semibold.$value }}>
                {cpaIncome}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              RS INCOME
              <Box sx={{ fontWeight: typography.Font_weight.Semibold.$value }}>
                {rsIncome}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              TOTAL INCOME
              <Box sx={{ fontWeight: typography.Font_weight.Semibold.$value }}>
                {totalIncome}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              PV
              <Box sx={{ fontWeight: typography.Font_weight.Semibold.$value }}>
                {pv}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              EPC
              <Box sx={{ fontWeight: typography.Font_weight.Semibold.$value }}>
                {epc}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              EPC CPA
              <Box sx={{ fontWeight: typography.Font_weight.Semibold.$value }}>
                {epcCpc}
              </Box>
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </>
  );
};

export default BrandsSearchItemsMoreMetrics;
